import { render } from "./RTV.vue?vue&type=template&id=4925c196"
import script from "./RTV.vue?vue&type=script&lang=js"
export * from "./RTV.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__